import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows } from "../../datatablesource";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import axios from "axios";

const Datatable = ({ columns }) => {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  // const paths = location.pathname.split("/")[2];
  const [list, setList] = useState([]);
  const { data, loading, error } = useFetch(`https://api.mecdistanceeducation.com/api/${path}`);
  console.log("Datatable Data", data);
  // console.log("paths",paths);

  // const condition = false; // You can set your condition here

  // useEffect(() => {
  //   if (paths && paths === "teachers") {
  //   // if (condition) {
  //     const teacherObjects = data.filter(item => item.isTeacher);
  //     setList(teacherObjects)
  //     // console.log(teacherObjects);
  //     // console.log("list",list);

  //   } else {
  //     // Set the entire data array to list when condition is false
  //     setList(data);
  //   }
  // }, [condition, data]);

  // useEffect(() => {
  //   console.log("list",list); // Log the filtered data
  // }, [list]);

  // useEffect(() => {
  //   // Filter and log objects with isTeacher = true
  //   const teacherObjects = data.filter(item => item.isTeacher);
  //   console.log(teacherObjects);
  // }, []);

  useEffect(() => {
    setList(data);
  }, [data]);

  const handleDelete = async (id) => {
    // Ask the user for confirmation
    const isConfirmed = window.confirm("Are you sure you want to delete this item?");
    
    // If the user confirms the deletion, proceed
    if (isConfirmed) {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.delete(
          `https://api.mecdistanceeducation.com/api/${path}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        // Remove the deleted item from the list
        setList(list.filter((item) => item._id !== id));
      } catch (err) {
        console.error("Error deleting item:", err);
        // You can handle the error here, e.g., show a message to the user
      }
    }
  };
  
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/${path}/${params.row._id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row._id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        {path}
        <Link to={`/${path}/new`} className="link">
          Add New
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        // rows={data}
        rows={list}
        columns={columns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
        getRowId={(row) => row._id}
      />
    </div>
  );
};

export default Datatable;
